import React, { useState } from "react";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Contact Us", path: "/contact" },
  ];

  const NavLink = ({ to, children, className, onClick }) => (
    <a href={to} className={className} onClick={onClick}>
      {children}
    </a>
  );

  return (
    <>
      {/* Fixed Navbar */}
      <nav className="w-full bg-gray-50 shadow-md fixed top-0 left-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <NavLink to="/" className="flex-shrink-0">
              <div className="text-2xl font-extrabold text-[#023437]  hover:text-teal-900 transition-colors">
                LOGO
              </div>
            </NavLink>

            {/* Desktop Links + Phone */}
            <div className="hidden md:flex items-center space-x-10 text-lg font-medium">
              {navItems.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.path}
                  className="text-[#023437]  hover:text-teal-900 transition-colors"
                >
                  {item.name}
                </NavLink>
              ))}

              {/* Phone CTA */}
              <div className="flex items-center space-x-2 border-l border-gray-300 pl-6">
                <span className="font-medium text-[#023437] ">Live Help 24/7:</span>
                <a
                  href="tel:+18882011350"
                  className="font-bold text-gray-900 hover:text-[#023437]  transition-colors"
                >
                  (888)-201-1350
                </a>
              </div>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-[#023437]  hover:text-teal-900 focus:outline-none transition-colors"
                aria-label="Toggle menu"
              >
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  {isMenuOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  )}
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden border-t border-gray-300 bg-gray-50 shadow-lg">
              <div className="px-4 pt-4 pb-6 space-y-3">
                {navItems.map((item) => (
                  <NavLink
                    key={item.name}
                    to={item.path}
                    className="block px-4 py-2 text-base font-medium text-[#023437]  hover:text-teal-900 hover:bg-gray-100 rounded-lg transition-colors"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </NavLink>
                ))}

                {/* Mobile Phone CTA */}
                <div className="px-4 pt-4 border-t border-gray-300">
                  <span className="block text-sm font-medium text-[#023437]  mb-1">
                    Live Help 24/7:
                  </span>
                  <a
                    href="tel:+18882011350"
                    className="block text-lg font-bold text-gray-900 hover:text-[#023437]  transition-colors"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    (888)-201-1350
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Content Spacer to offset fixed navbar */}
      <div className="h-16"></div>
    </>
  );
};

export default Navbar;
